import React from 'react';
import { Badge, Button, PaddedSection } from '../../atoms';
import { genClassName } from '../../../utils/helpers';
import { ImageType } from '../../../utils/types';

import './styles.css';

type Props = {
	heading: string;
	image: ImageType;
	badge?: {
		label: string;
		text?: string;
	};
	subheading?: string;
	buttonLabel?: string;
	href?: string;
	className?: string;
};

/**
 *
 * @typedef {Object} Props
 * @prop {String} heading
 * @prop {ImageType} image
 * @prop {Object} [badge]
 * @prop {String} [subheading]
 * @prop {String} [buttonLabel]
 * @prop {String} [href]
 * @prop {String} [className]
 *
 * @augments {Component<Props>}
 */
const TextImageStacked: React.FC<Props> = (props: Props) => {

	const { heading, image, badge, subheading, buttonLabel, href, className } = props;

	return (
		<PaddedSection className={genClassName('TextImageStacked', className ? className : '')}>
			<div className='TextImageStacked-content'>
				{badge && <Badge {...badge} />}
				<h1>{heading}</h1>
				{subheading && <p>{subheading}</p>}
				{href && buttonLabel ? (
					<Button className='TextImageStacked-button' href={href}>
						{buttonLabel}
					</Button>
				) : null}
			</div>
			<img
				className='TextImageStacked-image'
				src={require(`../../../assets/images/${image.src}`)}
				alt={image.alt}
			/>
		</PaddedSection>
	);

};

export default TextImageStacked;
